/**
 * useAvailableTransitions - Fetch available transitions with requirements
 */

import { useQuery } from '@tanstack/react-query';
import { api } from '../lib/api';
import type { StatusChecklistRequirement } from '@leal-crm/shared';

export interface AvailableTransition {
  transitionId: string;
  toStatus: string;
  toStatusLabel: string;
  toStatusColors: { text: string; bg: string; border: string };
  toStatusMeta?: {
    id: string;
    code: string;
    name: string;
    statusType: string;
    color: string;
    bgColor: string | null;
    borderColor: string | null;
    icon: string | null;
  };
  dialogType: string;
  dialogConfig: Record<string, unknown> | null;
  minTimeInStatusMinutes?: number | null;
  maxTimeInStatusMinutes?: number | null;
  requirements: StatusChecklistRequirement[];
  canExecute: boolean;
  errors: string[];
}

export function useAvailableTransitions(bookingId: string | undefined) {
  return useQuery({
    queryKey: ['bookings', bookingId, 'available-transitions'],
    queryFn: async () => {
      if (!bookingId) return [];
      const response = await api.get<AvailableTransition[]>(
        `/api/bookings/${bookingId}/available-transitions`
      );
      return response;
    },
    enabled: !!bookingId,
    staleTime: 15 * 1000,
  });
}
